// legacy build（pdfjs-dist/legacy/build/pdf）は .mjs 拡張子の型定義（.d.mts）しか
// 持たず、CRA の tsconfig（moduleResolution: node）では解決できずビルドが失敗する
// （`pdfjs-dist/legacy/build/pdf` の型が見つからない）。そのため通常ビルドを使う。
// jsdom（単体テスト環境）では "Please use the legacy build in Node.js environments"
// という警告が出るだけで、実際の動作・カバレッジには影響しない。
import * as pdfjsLib from 'pdfjs-dist';

/**
 * pdf.js の Worker 設定を1箇所に集約する。
 *
 * webpack5（react-scripts 5 / CRA5）は `new URL('...', import.meta.url)` の形を
 * Worker 用アセットとして認識し、ビルド時に正しいパスへ書き換える。
 * これは pdf.js 公式ドキュメントが webpack5 系バンドラー向けに案内している方法で、
 * 外部CDNに依存しない（院内オフライン環境でも動く）。
 */
pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url
).toString();

export default pdfjsLib;
